import { Stack } from '@mui/material';
import { ReactNode } from 'react';

type PageHeaderFiltersProps = {
  /**
   * Filter controls that scope the entity shown in the title — typically
   * multi-selects, pill buttons, or filter dropdowns. Unconstrained
   * `ReactNode`. See ADR-008.
   */
  children: ReactNode;
};

export const PageHeaderFilters = ({ children }: PageHeaderFiltersProps) => {
  return (
    <Stack direction="row" gap={1} alignItems="center" flexShrink={1} sx={{ minWidth: 0 }}>
      {children}
    </Stack>
  );
};
